// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { formatToMoney } from '@advisor-app/features/utils/format-to-money';
import { formatToPercent } from '@shared/ui-kit/utils';
import { Heading, SectionContainer } from '@shared/ui-kit/components';
import { useState } from 'react';
import { HistoryPortfolio } from './history-portfolio';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';

interface BrokerBalanceProps {
  equity: number | undefined;
}

export const BrokerBalance = ({ equity }: BrokerBalanceProps) => {
  const [profitsAndPercentage, setProfitsAndPercentage] = useState({
    profit: 0,
    percentage: 0,
  });

  return (
    <SectionContainer>
      <div className="broker-home-broker-title">
        <div className="flex flex-col space-y-2">
          <Heading
            variant="h2"
            title={<Translation i18nKey="dashboard.investments" ns="dashboard" />}
            popupName="dashboard.investments"
            tooltip
          />
          <div className="flex flex-row space-x-2">
            <span className="!money-display font-[poppins] text-3xl font-semibold text-title-alt">
              {formatToMoney(Math.trunc(equity || 0), undefined, 0)}
            </span>
            <span
              data-profit={profitsAndPercentage.profit >= 0}
              className="!money-display mb-0.5 self-end font-[poppins] font-semibold leading-[22px] text-negative data-[profit=true]:text-positive"
            >
              {formatToMoney(profitsAndPercentage.profit, undefined, 0)} (
              {formatToPercent(profitsAndPercentage.percentage)})
            </span>
          </div>
        </div>
      </div>
      <HistoryPortfolio
        profitsAndPercentage={profitsAndPercentage}
        setProfitsAndPercentage={setProfitsAndPercentage}
        equity={equity}
      />
    </SectionContainer>
  );
};
